<template>
  <v-row class="d-flex align-center mt-16">
    <v-item-group v-model="window" mandatory>
      <v-item v-for="n in length" :key="n" v-slot="{ active, toggle }">
        <div>
          <v-btn class="ml-9" :input-value="active" icon @click="toggle">
            <v-icon>mdi-record</v-icon>
          </v-btn>
        </div>
      </v-item>
    </v-item-group>
    <v-col>
      <v-window v-model="window" vertical flat>
        <v-window-item v-for="(service, index) in services" :key="index">
          <v-card class="mx-4">
            <v-card-text class="pa-0">
              <strong class="primary--text text--darken-4 text-h5 font-weight-medium ml-7">{{
                service.name
              }}</strong>
              <v-spacer></v-spacer>
              <v-col xs12 sm12 md10 lg10>
                <v-card-text class="d-flex flex-wrap flex-md-nowrap flex-sm-wrap pa-0" grid-list-sm>
                  <v-card v-for="(tool, index) in service.tools" :key="index" class="mt-10 mx-4">
                    <div class="d-flex justify-center my-3">
                      <v-avatar class="primary mt-7" size="130">
                        <v-icon size="100">{{ tool.icon }}</v-icon>
                      </v-avatar>
                    </div>
                    <v-card-title class="subtitle-1 justify-center font-weight-medium mx-0">{{
                      tool.name
                    }}</v-card-title>
                    <v-card-text>
                      <v-row class="d-flex align-center mx-0 mt-1">
                        <p class="body-2 black--text text-center">
                          {{ tool.description }}
                        </p>
                      </v-row>
                    </v-card-text>
                    <v-col xs="12" class="px-0">
                      <v-row
                        v-for="(utilization, index) in tool.utilizations"
                        :key="index"
                        class="d-flex justify-start ml-4 my-3"
                      >
                        <div v-if="utilization.check == true">
                          <v-icon class="primary3--text mr-1">{{ servicesIcons.iconCheck }}</v-icon>
                        </div>
                        <div v-else>
                          <v-icon class="primary3--text mr-1">{{ servicesIcons.iconPause }}</v-icon>
                        </div>
                        <a class="primary2--text text-subtitle-2">{{ utilization.name }}</a>
                        <div class="text-xs-center" v-if="utilization.check == false">
                          <v-chip class="primary3--text white px-1 pb-2" x-small>
                            {{ service.alert }}
                          </v-chip>
                        </div>
                      </v-row>
                    </v-col>
                  </v-card>
                </v-card-text>
              </v-col>
            </v-card-text>
          </v-card>
        </v-window-item>
      </v-window>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'VSlidesServices',
  props: ['services', 'length', 'servicesIcons'],
  data() {
    return {
      window: 0,
    };
  },
};
</script>
